import { createRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '@/router/root-route';
import LoginPage from '@/features/login/LoginPage';
import { getKeycloak } from '@/auth/keycloak-instance';
import { safeReturnPath } from '@/auth/return-path';
import { DEFAULT_COMPANIES_SEARCH } from '@/features/companies/companies-list/companies-search.schema';

const loginSearchSchema = z.object({
  reason: z.enum(['unauthorized']).optional(),
  /**
   * EU-756 (OKR-003): the path the visitor asked for before being sent here by
   * the `_authenticated` guard. Untrusted (it comes from the URL) — every reader
   * passes it through `safeReturnPath`, which only keeps same-origin paths.
   */
  redirect: z.string().optional().catch(undefined),
});

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  validateSearch: loginSearchSchema,
  beforeLoad: ({ search }) => {
    if (getKeycloak().authenticated && search.reason !== 'unauthorized') {
      // Already logged in (e.g. back button onto /login): go where they were
      // headed, or home when there is no safe destination.
      const returnTo = safeReturnPath(search.redirect);
      if (returnTo) throw redirect({ href: returnTo });
      throw redirect({ to: '/', search: DEFAULT_COMPANIES_SEARCH });
    }
  },
  component: LoginPage,
});
